import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import TabsMainCC from "./TabsMainCC";
import LeadData from "./LeadData";
import AddNewContactCards from "./AddNewContactCards";
import Service from "../../services";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import StatusTab from "./StatusTab";
import "./prospectingDetailsPage.scss";
import ScheduleA from "./ScheduleA";
import { useParams } from "react-router-dom";
import { BankUserContext } from "../../bankUserContext";
import { TriggerContext } from "../../Context/TriggerContext";
import RoleAuthorization from "../Authentication/RoleAuthorization";
import { Pages, actionAuthorization } from "../../utils/RolesUtil";

const LeadDetailsDisplay = () => {
  const [contactsData, setContactsData] = useState([]);
  const [leadData, setLeadData] = useState<any>();
  const [searchVal, setSearchVal] = useState<string>("");
  const [activeTab, setActiveTab] = useState("1");
  const [loader, setLoader] = useState(Boolean);
  const [loadStausTab, setLoadStausTab] = useState<Boolean>(false);

  // docu sign states - 
  const [iframeActivate, setIframeActivate] = useState(false)
  const [iframeUrl, setIframeUrl] = useState('')

  const { clientId, clientProductsId } = useParams();
  const service = new Service();
  const context = useContext(BankUserContext)
  const triggerContext = useContext(TriggerContext);

  const getAddContact = (search = "") => {
    let payload = {
      orgId: context.bankuserDetails?.organization.orgId,
      screen: "ProspectDetails",
      sections: "GetClientContacts",
      clientId: clientId,
      parentClientId: (leadData && leadData[0]?.parentClientId) || clientId,
      isJsonReturnObject: false,
      search,
      businessName: leadData && leadData[0]?.businessInfo[0]?.businessName,
      clientProductsId: clientProductsId,
    };

    clientProductsId && service
      .getRolodexContactsData(payload).then((res: any) => {
        const sortedData = res.data.sort((a: any, b: any) => {
          return b.primary - a.primary
        })
        setContactsData(sortedData);
      })
      .catch((err: any) => { });
  };

  const handleSearch = (value: string) => {
    setSearchVal(value);
  };

  useEffect(() => {
    const clientActionId = localStorage.getItem('clientActionId');
    const status = localStorage.getItem('status')
    getAddContact();
    if (clientActionId) {
      if (clientActionId !== 'null' && clientActionId.length > 0) {
        setActiveTab('2')
      }
    }
    if(status){
      setActiveTab('2')
    }

  }, [searchVal, leadData]);

  const activeStatusTabHandler = () => {
    setActiveTab("1");
    setLoadStausTab(!loadStausTab);
  }

  const getLeadData = () => {
    setLoader(true);
    let payload = {
      screen: "ProspectDetails",
      sections: "ProspectInfo",
      clientId: clientId,
      clientProductsId: clientProductsId,
      isJsonReturnObject: true,
    };
    service
      .getLeadsData(payload)
      .then((res: any) => {
        const temp = res?.data?.map((r: any) => {
          const temp = r.contactInfo && r.contactInfo[0] || [];
          const temp2 = r.businessInfo && r.businessInfo[0] || [];

          r.clientLabels = r.clientLabels || [];
          r.clientLabels = r.clientLabels.map((l: any) => {
            l.value = l.labelMasterId;
            return l;
          });

          if (r.contactInfo && r.contactInfo[0]) {
            r.contactInfo[0].address = [
              temp?.streetAddress || "",
              temp?.unitSuite || "",
              [temp?.city || " ", temp?.state || " ", temp?.zipCode || " "].join(
                " "
              ),
            ].filter((d: any) => d)
          }
          if (r.businessInfo && r.businessInfo[0]) {
            r.businessInfo[0].address = [
              temp2?.businessStreetAddress || "",
              temp2?.businessUnitSuite || "",
              [
                temp2?.businessCity || "",
                temp2?.businessState || "",
                temp2?.businessZipCode || "",
              ].join(" "),
            ].filter((d: any) => d);
            return r;
          }
        });
        setLeadData(temp);
        temp && temp.length > 0 && triggerContext?.setReadOnlyMode(temp[0]?.readOnlyMode);
        setLoader(false);
      })
      .catch((err: any) => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (triggerContext?.triggerLeadDetails) {
      getLeadData();
      triggerContext?.setTriggerLeadDetails(false)
    }

  }, [triggerContext]);

  return (
    <>

      {iframeActivate && iframeUrl ? (
        <div className="iframeContainer">
          {/* <iframe src={iframeUrl} title="docuSign" height={1000} width="100%"></iframe> */}
          <iframe src={iframeUrl} name="iframe_a" height="1000px" width="100%" title="Iframe Example"></iframe>
        </div>
      ) : (

        <div>
          <div>
            <LeadData leadData={leadData} getLeadData={getLeadData} trackerName={"LORATrackers"} />
          </div>
          <div className={`tabs-container detailsTabs`}>
            <div className="nav-tabs">
              <Nav tabs className="tabs-bottom">
                <NavItem>
                  <NavLink
                    className={activeTab === "1" ? "active" : ""}
                    onClick={() => activeStatusTabHandler()}
                  >
                    Status
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    disabled={!clientProductsId}
                    className={activeTab === "2" ? "active" : ""}
                    onClick={() => setActiveTab("2")}
                  >
                    Details
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <StatusTab
                    leadData={leadData}
                    getLeadData={getLeadData}
                    setIframeActivate={setIframeActivate}
                    setIframeUrl={setIframeUrl}
                    loadStausTab={loadStausTab}
                  />
                </TabPane>
                <TabPane tabId="2">
                  {" "}
                  {<Container fluid>
                    <Row>
                      <Col md={9} className="max-78">
                        <TabsMainCC triggerContext={triggerContext}/>
                      </Col>
                      {RoleAuthorization(Pages.customerDetailsPage, actionAuthorization.viewRolodex) && <Col md={3} className="max-22 pr-0">
                        <AddNewContactCards
                          leadData={contactsData}
                          msgButton={true}
                          addNewContactBtn={true}
                          searchItem={handleSearch}
                          placeholder={"Search Contacts"}
                          editContactBtn={true}
                          clientId={clientId}
                          productId={clientProductsId}
                          parentClientId={leadData && leadData[0]?.parentClientId}
                          getAllContacts={getAddContact}
                          getLeadData={getLeadData}
                          clientProductsContactMappingId={leadData && leadData[0]?.clientProductsContactMappingId}
                        />
                      </Col>}
                    </Row>
                  </Container>}
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeadDetailsDisplay;
